<template>
    <div class="newsXq">
        <p class="title">{{htmlText.title}}</p>
        <p class="desc"><span>来源：{{htmlText.source}}</span>      <span class="mar">发布时间：{{htmlText.createTime}}</span></p>
        <div class="contentHtml" v-html="htmlText.text"></div>
        <div class="button">
            <span class="back" @click="$router.go(-1)">返回</span>
            <div class="page">
                <span :class="['prev',htmlText.preId?'':'disabled']" @click="gotoXq(htmlText.preId)">上一篇</span>
                <span :class="[htmlText.postId?'':'disabled']" @click="gotoXq(htmlText.postId)">下一篇</span>
            </div>
        </div>
    </div>
</template>
    
<script>
    import api from '@/api/api'
    export default{
        data(){
            return{
                htmlText:""
            }
        },
        watch:{
            $route(){
                this.getInfo()
            }
        },
        methods:{
            gotoXq(id){
                if(id){
                    this.$router.push({
                        name:'EncyclopediaXq',
                        params:{id}
                    })
                }else{
                    return false;
                }
            },
            getInfo(){
                api.getXq({
                    id:this.$route.params.id
                }).then(res=>{
                    if(res.data.code===0){
                        this.htmlText = res.data.data.newsDetail;
                    }
                })
            }
        },
        created(){
            this.getInfo()   
        }
    }
</script>
<style lang="scss" scoped>
    .newsXq{
        width: 1200px;
        margin: 0 auto;
        margin-top: 30px;
        .title{
            width: 100%;
            text-align: center;
            line-height: 34px;
            font-size: 28px;
            font-weight: bold;
        }
        .desc{
            font-size: 16px;
            line-height: 24px;
            color: #606266;
            text-align: center;
            margin-top: 12px;
            padding-bottom: 22px;
            border-bottom: 1px solid #C0C4CC;
            span.mar{
                margin-left: 30px;
            }
        }
        .button{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 100px;
            span{
                display: inline-block;
                width: 100px;
                height: 52px;
                line-height: 52px;
                border: 1px solid #979797;
                font-size: 18px;
                color: #303133;
                text-align: center;
                cursor: pointer;
                &:hover{
                    border-color: #1797E0;
                    color: #1797E0;
                }
                &:active{
                    border-color: #1484C4;
                    color: #1484C4;
                }
            }
            .prev{
                margin-right: 20px;
            }
            .disabled{
                cursor: not-allowed;
                border-color: #C0C4CC;
                color: #C0C4CC;
                &:hover{
                    border-color: #C0C4CC;
                    color: #C0C4CC;
                }
                &:active{
                    border-color: #C0C4CC;
                    color: #C0C4CC;
                }
            }
        }
    }
    @media screen and (max-width: 1200px){
        .newsXq{
            width: 100%;
            box-sizing: border-box;
            padding: 0 16px;
            .title{
                font-size: 20px;
            }
            .desc{
                font-size: 14px;
                .mar{
                    margin-left: 16px;
                }
            }
            .button{
                span{
                    width: 60px;
                    height: 40px;
                    line-height: 40px;
                    font-size: 16px;
                }
                .page{
                    .prev{
                        margin-right: 10px;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Encyclopedia/EncyclopediaXq.vue